import { useOverlays } from "contexts/OverlayContext";
import { DocumentMatchDrawer } from "./DocumentMatchDrawer";

export const DocumentMatchDrawerWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();

    const overlayInfo = getOverlayInfo<"documentAccrualMatch">(
        "documentAccrualMatch",
    );

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <DocumentMatchDrawer
            open={!overlayIsClosing}
            onClose={closeOverlay}
            documentType={overlayInfo.data.documentType}
            documentId={overlayInfo.data.documentId}
        />
    );
};
